export class proposalData  {
    firstName: string = '';
    lastName: string = '';
    mobile: string = '';
    email: string = '';
    sumInsured: string = '';
    title : string = '';
    address1 : string = '';
    address2 : string = '';
    dob : string = '';
    // adhaar : string = '';
    pincode : string = '';
    city : string = '';
    state : string = '';
    nomineeName : string = '';
    nomineeRelation : string = '';
    prospectId : string = '';
    quoteId : string = '';
    tpa: any = 'Medi Assist Insurance (TPA) Pvt Ltd';
    medicineBranch: string = '';
    qualification: string;
    selectedSpecialization: string;
    retroactiveDate: Date;
    yearOfReg: string;
    avgPatient: string;
    medicalReg: string;
    practiceYear: string;
    member: string;
    AssoName: string;
    AssoConact: string;
    assoAddress: string;
    form: any;
    year: string;

    designation : string;
    annualIncome: string;
    pan: string;
    adhaar: string;
    engineNumber: string;
    vehicleRegNum: string;
    chasisNumber: string;
    manufacturer : string;
    carModel: string;

    authorizedSignatoryDate: any;
    nomineeDob: any;
    totalMembers: string;
    quoteDetailId: string;
    insurerName: string;
    age: string;
    productName: string;
    premiumValIncludingTax: string;
    guardianRelationship1: any;
    guardianTitle: any;
    guardianFirstName: any;
    guardianLastName: any;
    guardianAge: any;
    guardianDob: any;
    guardianMobile: any;
    guardianAddress1: any;
    guardianAddress2: any;
    guardianPincode: any;
    guardianCity: any;
    guardianState: any;
    physicianTitle: string;
    physicianName: string;
    physicianStdCode: string;
    physicianPhoneNumber: string;
    physicianMobileNumbe: string;
    nomineeAddressAutoFill: string;
    fromProposalPage: string;
    hospitalCashBenifit: any;
    nomineeAddress1: string;
    nomineePincode: string;
    nomineeState: string;
    nomineeCity: string;
    guardianAge1: number;
    typeOfPlan: string;
    insurerDob1: any;
    insurerDob2: any;
    insurerDob3: any;
    insurerDob4: any;
    insurerDob5: any;
    insuredPersonSrNo1: any = 1;
    insuredPersonSrNo2: any = 2;
    insuredPersonSrNo3: any = 3;
    insuredPersonSrNo4: any = 4;
    insuredPersonSrNo5: any = 5;
    adults: any;
    childs: any;
    designation1:any = '';
    designation2:any = '';
    designation3:any = '';
    designation4:any = '';
    designation5:any = '';
    business1:any = '';
    business2:any = '';
    business3:any = '';
    business4:any = '';
    business5:any = '';
    //insurerMemberRelation: any;
    // insurerMemberRelation1: any = 'Self';
    // insurerMemberRelation2: any = 'Spouse';
    // insurerMemberRelation3: any;
    // insurerMemberRelation4: any;
    // insurerMemberRelation5: any;
    addtionalMedicalDetailCheck1:string = 'No';
    healthCheckUp1:string = 'No';
    healthDetailedInvestigation1:string = 'No';
    hospatalizedLastFiveYears1:string = 'No';
    insurarTakeMedicineOnRegularBasis1:string = 'No';
    insurerHealthProblemInLastThreeMonth1:string = 'No';
    insuredPersonTakenTreatmentOrHospitalized1:string = 'No';
    addtionalMedicalDetailCheck2:string = 'No';
    healthCheckUp2:string = 'No';
    healthDetailedInvestigation2:string = 'No';
    hospatalizedLastFiveYears2:string = 'No';
    insurarTakeMedicineOnRegularBasis2:string = 'No';
    insurerHealthProblemInLastThreeMonth2:string = 'No';
    insuredPersonTakenTreatmentOrHospitalized2:string = 'No';
    addtionalMedicalDetailCheck3:string = 'No';
    healthCheckUp3:string = 'No';
    healthDetailedInvestigation3:string = 'No';
    hospatalizedLastFiveYears3:string = 'No';
    insurarTakeMedicineOnRegularBasis3:string = 'No';
    insurerHealthProblemInLastThreeMonth3:string = 'No';
    insuredPersonTakenTreatmentOrHospitalized3:string = 'No';
    addtionalMedicalDetailCheck4:string = 'No';
    healthCheckUp4:string = 'No';
    healthDetailedInvestigation4:string = 'No';
    hospatalizedLastFiveYears4:string = 'No';
    insurarTakeMedicineOnRegularBasis4:string = 'No';
    insurerHealthProblemInLastThreeMonth4:string = 'No';
    insuredPersonTakenTreatmentOrHospitalized4:string = 'No';
    addtionalMedicalDetailCheck5:string = 'No';
    healthCheckUp5:string = 'No';
    healthDetailedInvestigation5:string = 'No';
    hospatalizedLastFiveYears5:string = 'No';
    insurarTakeMedicineOnRegularBasis5:string = 'No';
    insurerHealthProblemInLastThreeMonth5:string = 'No';
    insuredPersonTakenTreatmentOrHospitalized5:string = 'No';
    bmi1: any;
    bmi2: any;
    bmi3: any;
    bmi4: any;
    bmi5: any;
    height1: any;
    height2: any;
    height3: any;
    height4: any;
    height5: any;
    weight1: any;
    weight2: any;
    weight3: any;
    weight4: any;
    weight5: any;
    proposerOccupation: any = 'SALARIED';
    occupation1: any = 'SALARIED';
    occupation2: any = 'SALARIED';
    occupation3: any;
    occupation4: any;
    occupation5: any;
    insuredPersonFirstName1: string = '';
    insuredPersonLastName1: string = '';
    insuredPersonGender1: string = '';
    insurertreatmentStatus1: string = 'Received';
    insurertreatmentStatus2: string = 'Received';
    insurertreatmentStatus3: string = 'Received';
    insurertreatmentStatus4: string = 'Received';
    insurertreatmentStatus5: string = 'Received';
    smokingInsurer1: string = 'No';
    smokingInsurer2: string = 'No';
    smokingInsurer3: string = 'No';
    smokingInsurer4: string = 'No';
    smokingInsurer5: string = 'No';
    insurerConsumeNarcotics1: string = 'No';
    insurerConsumeNarcotics2: string = 'No';
    insurerConsumeNarcotics3: string = 'No';
    insurerConsumeNarcotics4: string = 'No';
    insurerConsumeNarcotics5: string = 'No';
    insurerConsumeAlcohol1: string = 'No';
    insurerConsumeAlcohol2: string = 'No';
    insurerConsumeAlcohol3: string = 'No';
    insurerConsumeAlcohol4: string = 'No';
    insurerConsumeAlcohol5: string = 'No';
    insurerConsumeTobacco1: string = 'No';
    insurerConsumeTobacco2: string = 'No';
    insurerConsumeTobacco3: string = 'No';
    insurerConsumeTobacco4: string = 'No';
    insurerConsumeTobacco5: string = 'No';
    constructor() {
    }
}